export const histogram2d = {
  colorscale: [['0', '#4285F4'], ['1', '#DB4437']],
  colorbar: {
    len: 1,
    outlinewidth: 0
  }
}



// WEBPACK FOOTER //
// ./src/types/histogram2d.js